




























































































































































import Vue from "vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import { Device } from "@/store/modules/Device/interface";
import { StateEnum } from "@/types/types";

export default Vue.extend({
  name: "DescriptionBar",
  components: { NavbarTitle },
  props: {
    should_be_displayed: {
      type: Boolean,
      default: false
    },
    device: {
      type: Object as () => Device
    }
  },
  data() {
    return {
      classes: "card_scrollable container-d absolute"
    };
  },
  methods: {
    close(): void {
      this.$emit("close");
    },
    edit(): void {
      this.$emit("close");
      this.$emit("edit", this.device._id);
    }
  },
  computed: {
    defineDisponibilityColor(): string {
      return this.device.state === StateEnum.RESERVE_DISP ? "var(--button-yes-color)" : "var(--button-no-color)";
    }
  },
  watch: {
    should_be_displayed() {
      if (this.should_be_displayed) this.classes = "card_scrollable container-u absolute container-up";
      else this.classes = "card_scrollable container-d absolute container-down";
    }
  }
});
